// As this app is not translated, we don't use the shared hook useTransformName

const transformName = (
  firstName?: string | null,
  lastName?: string | null,
  inactive?: boolean
): string =>
  (firstName || lastName
    ? `${firstName ? firstName : ""}${
        lastName ? (firstName ? " " : "") + lastName : ""
      }`
    : "N/A") + (inactive ? ` (inactive)` : "");

export default transformName;
